import { cn } from "@/lib/utils";
import { memo } from "react";

type ShimmerProps = {
  children: string;
  className?: string;
};

const ShimmerComponent = ({ children, className }: ShimmerProps) => {
  return (
    <span
      className={cn(
        "inline-block bg-[length:250%_100%,auto] bg-clip-text text-transparent",
        "[background-repeat:no-repeat,padding-box]",
        "animate-[shimmer-slide_2s_linear_infinite]",
        className,
      )}
      style={{
        backgroundImage: `linear-gradient(90deg, transparent calc(50% - ${children.length * 2}px), var(--color-background), transparent calc(50% + ${children.length * 2}px)), linear-gradient(var(--color-muted-foreground), var(--color-muted-foreground))`,
      }}
    >
      {children}
    </span>
  );
};

export const Shimmer = memo(ShimmerComponent);
